

export default function FinalFooterLine2(){
   return <p className="font-normal 9:text-center">© 2023 Airbnb, Inc.</p>
}